import React, { Children } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import media from '../../utils/Breakpoints';

const StyledMenu = styled.div`
	padding: 8px;
	position: absolute;
	left: 0;
	bottom: 24px;
	display: flex;
	align-items: flex-start;
	width: auto;
	max-width: 100%;
	overflow-y: hidden;
	overflow-x: auto;
	-webkit-overflow-scrolling: touch;

	${media.sm`
		bottom: 32px;
	`}
	@media ${media.sm} {
		bottom: 45px;
  	}

	${media.md`
		bottom: 0px;
	`}

	${media.lg`
		left: 8px;
		overflow: visible;
	`}

	${media.xl`
		left: 24px;
		bottom: 24px;
	`}

	@media screen and (min-width: 1366px) and (max-height: 768px) and (orientation: landscape) {
		transform: scale(.752);
		transform-origin: bottom left;
	}

	&::after {
		display: block;
		content: '';
		flex-shrink: 0;
		width: 8px;
		height: 100%;
		min-height: 1px;
	}
`;

export default function Menu({ isVisible, children }) {
	return <StyledMenu isVisible={isVisible}>{Children.toArray(children)}</StyledMenu>;
}

Menu.propTypes = {
	isVisible: PropTypes.bool,
	children: PropTypes.node.isRequired,
};
